module.exports = __webpack_public_path__ + "img/female3.c08e1024.jpg";